<template>
    <!-- 派对订单详情 -->
    <div>
        <content-view class="parte-order-detail">
            <template slot="header">
                
            </template>
            <a-spin :spinning="Boolean(spinning)">
                <div id="parte-order-detail-header">
                    <div class="pl32 pr32">
                        <a-row class="mb8">
                            <a-col :span="12" class="font-biggest">订单号：{{detailData.id}}</a-col>
                            <a-col class="text-right" :span="12">
                                <a-button type="primary" v-if="getBtnByAuth('adminPartyOrderCancel') && detailData.status === 1 && !Boolean(detailData.hasProceedsAndCreate)" @click="openCancel">取消</a-button>
                                <a-button type="primary" v-if="getBtnByAuth('adminPartyOrderFile') && detailData.status === 1 && Boolean(detailData.hasProceedsAndCreate)" @click="openFile">归档</a-button>
                            </a-col>
                        </a-row>
                        <a-row class="mb8">
                            <a-col :span="12">创建人：{{detailData.createUser}}</a-col>
                            <a-col :span="12">
                                <a-row>
                                    <a-col class="text-right text-disabled" :span="16">状态</a-col>
                                    <a-col v-if="detailData.status !== 3" class="text-right text-disabled" :span="8">订单预售金额（元）</a-col>
                                    <a-col v-else class="text-right text-disabled" :span="8">订单实收（元）</a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                        <a-row>
                            <a-col :span="12">创建时间：{{detailData.createTime}}</a-col>
                            <a-col :span="12">
                                <a-row>
                                    <a-col class="text-right font-biggest" :span="16">{{detailData.status | partyOrderStatus}}</a-col>
                                    <a-col v-if="detailData.status !== 3" class="text-right font-biggest" :span="8">{{detailData.totalPresell | myToFixed2 | thousandFormat}}</a-col>
                                    <a-col v-else class="text-right font-biggest" :span="8">{{detailData.payment | myToFixed2 | thousandFormat}}</a-col>
                                </a-row>
                            </a-col>
                        </a-row>
                        <div class="parte-order-detail-tabs">
                            <a-tabs :activeKey="activeKey" @change="changeTab" :animated="false" :tabBarStyle="tabBarStyle">
                                <a-tab-pane tab="订单明细" :key="1"></a-tab-pane>
                                <a-tab-pane tab="收支明细" :key="2"></a-tab-pane>
                                <a-tab-pane v-if="detailData.status === 3" tab="归档结算" :key="3"></a-tab-pane>
                                <a-tab-pane tab="操作记录" :key="4"></a-tab-pane>
                            </a-tabs>
                        </div>
                    </div>
                </div>
                <a-card class="mb24 party-order-detail-block" :bordered="false">
                    <div class="font-big font700 mb16">基础信息</div>
                    <a-row class="mb16">
                        <a-col :span="8">客户名称：{{detailData.customerName}}</a-col>
                        <a-col :span="8">客户手机号：{{detailData.customerPhone}}</a-col>
                        <a-col :span="8">销售类型：{{detailData.sellType}}</a-col>     
                    </a-row>
                    <a-row>
                        <a-col :span="8">派对负责人：{{detailData.partyStaff}}</a-col>
                        <a-col :span="8">备注：{{detailData.remark}}</a-col>
                    </a-row>
                    <a-divider />
                    <div class="font-big font700 mb16">派对信息</div>
                    <a-row class="mb16">
                        <a-col :span="8">派对日期：{{detailData.partyDate}}</a-col>
                        <a-col :span="8">派对时间：{{Boolean(detailData.partyStartTime) ? detailData.partyStartTime.substring(0,5) : ''}}-{{Boolean(detailData.partyEndTime) ? detailData.partyEndTime.substring(0,5) : ''}}</a-col>   
                        <a-col :span="8">派对门店：{{detailData.shopName}}</a-col>    
                    </a-row>
                    <a-row class="mb16">
                        <a-col :span="8">派对类型：{{detailData.partyType}}</a-col>   
                        <a-col :span="8">派对主题：{{detailData.partyTitle}}</a-col>   
                    </a-row>
                    <a-row class="mb16">
                        <a-col :span="8">派对成人数(人）：{{detailData.adultNum}}</a-col>
                        <a-col :span="8">派对儿童数(人）：{{detailData.babyNum}}</a-col>       
                    </a-row>
                    <a-divider />
                    <div class="font-big font700 mb16">派对人员信息</div>
                        <a-table
                        bordered
                        :columns="columns"
                        :dataSource="detailData.partyOrderBabyVoList"
                        :pagination="false"
                        :rowKey="(record, index) => index">
                    </a-table>
                    <div class="font-big font700 mb16 mt16">预售费用明细</div>
                    <a-row class="mb16">
                        <a-col :span="8">票券预售金额：{{detailData.ticketPresell | myToFixed2 | thousandFormat}}</a-col>   
                        <a-col :span="8">餐饮预售金额：{{detailData.cateringPresell | myToFixed2 | thousandFormat}}</a-col>
                        <a-col :span="8">装饰预售金额：{{detailData.decoratePresell | myToFixed2 | thousandFormat}}</a-col>
                    </a-row>
                    <a-row class="mb16">
                        <a-col :span="8">增值服务预售金额：{{detailData.servicePresell | myToFixed2 | thousandFormat}}</a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="8">订单预售金额(元)：{{detailData.totalPresell | myToFixed2 | thousandFormat}}</a-col>
                    </a-row>
                </a-card>
                <a-card class="mb24 party-order-detail-block" title="收支明细">
                    <a-alert type="warning" class="mb16">
                        <template slot="message">
                            <a-row>
                                <a-col :span="8">预售金额（元）：{{detailData.totalPresell | myToFixed2 | thousandFormat}}</a-col>
                                <a-col :span="8">实收金额（元）：{{detailData.payment | myToFixed2 | thousandFormat}}</a-col>
                                <a-col :span="8">剩余预计应收金额（元）：<span class="text-fail">{{(detailData.totalPresell - detailData.payment) | myToFixed2 | thousandFormat}}</span></a-col>
                            </a-row>
                        </template>
                    </a-alert>
                    <a-row>
                        <a-col :span="4" class="font-big font700 mb24">收款记录</a-col>
                        <a-col :span="20" class="text-right">
                            <a-button type="primary" v-if="getBtnByAuth('adminPartyOrderCollection') && detailData.status === 1" @click="openCollection(false)">收款</a-button>
                            <a-button type="primary" v-if="getBtnByAuth('adminPartyOrderisRepairCollection') && detailData.status === 1" @click="openCollection(true)">补收款</a-button>
                        </a-col>
                    </a-row>
                    <a-table
                    bordered
                    :columns="columnsProceeds"
                    :dataSource="partyOrderProceedsData.partyOrderProceedsVos"
                    :pagination="false"
                    :rowKey="row => row.id"
                    >
                        <template slot="amount" slot-scope="key, row, index">
                            {{key | myToFixed2 | thousandFormat}}
                        </template>
                        <template slot="action" slot-scope="key, row, index">
                            <a class="text-primary" v-if="Boolean(row.hasFiles)" @click="openGetFiles(true, row.id)">附件</a>
                            <span v-else class="text-disabled">附件</span>
                        </template>
                    </a-table>
                    <div class="font-big font700 mt24">收款合计：{{partyOrderProceedsData.total | myToFixed2 | thousandFormat}}</div>
                    <a-divider />
                    <a-row>
                        <a-col :span="4" class="font-big font700 mb24">退款记录</a-col>
                        <a-col :span="20" class="text-right">
                            <template v-if="getBtnByAuth('adminPartyOrderRefund') && detailData.status === 1">
                                <a-button :disabled="!Boolean(detailData.hasProceedsAndCreate)" type="primary" @click="openRefund(false)">退款</a-button>
                            </template>
                            <template v-if="getBtnByAuth('adminPartyOrderisRepairRefund') && detailData.status === 1">
                                <a-button :disabled="!Boolean(detailData.hasProceedsAndCreate)" type="primary" @click="openRefund(true)">补退款</a-button>
                            </template>
                        </a-col>
                    </a-row>
                    <a-table 
                    bordered
                    :columns="columnsRefund"
                    :dataSource="partyOrderRefundData.partyOrderRefundVos"
                    :pagination="false"
                    :rowKey="(record, index) => index"
                    >
                        <template slot="amount" slot-scope="key, row, index">
                            {{key | myToFixed2 | thousandFormat}}
                        </template>
                        <template slot="action" slot-scope="key, row, index">
                            <a class="text-primary" v-if="Boolean(row.hasFiles)" @click="openGetFiles(false, row.id)">附件</a>
                            <span v-else class="text-disabled">附件</span>
                        </template>
                    </a-table>
                    <div class="font-big font700 mt24">退款合计：{{partyOrderRefundData.total | myToFixed2 | thousandFormat}}</div>
                </a-card>
                <a-card v-show="detailData.status === 3" class="party-order-detail-block mb24" title="归档结算">
                    <a-table
                    bordered
                    :columns="columnsArchive"
                    :dataSource="partyOrderArchiveData"
                    :pagination="false"
                    :rowKey="(record, index) => index"
                    >
                        <template slot="fontWeight" slot-scope="key, row, index">
                            <span :class="row.fontWeight ? 'font-weight font-big' : ''">
                                {{key}}
                            </span>
                        </template>
                        <template slot="myToFixed2" slot-scope="key, row, index">
                            <span :class="row.fontWeight ? 'font-weight font-big' : ''">
                                {{key | myToFixed2 | thousandFormat}}
                            </span>
                        </template>
                    </a-table>
                </a-card>
                <a-card class="party-order-detail-block" title="操作记录">
                    <a-table
                    bordered
                    :columns="columnsOperationLog"
                    :dataSource="partyOrderOperationLogData"
                    :pagination="false"
                    :rowKey="(record, index) => index"
                    >
                    </a-table>
                </a-card>
            </a-spin>
        </content-view>
        <party-order-get-files ref="partyOrderGetFiles" />
        <party-order-collection ref="partyOrderCollection" @cancel="reflash" />
        <party-order-refund ref="partyOrderRefund" @cancel="reflash" />
        <party-order-file ref="partyOrderFile" @cancel="reflash" />
        <party-order-cancel ref="partyOrderCancel" @cancel="reflash" />
    </div>
</template>
<script type="text/javascript">
    import partyOrderGetFiles from "@/components/modules/order/party-order-get-files.component";
    import partyOrderCollection from "@/components/modules/order/party-order-collection.component";
    import partyOrderRefund from "@/components/modules/order/party-order-refund.component";
    import partyOrderFile from "@/components/modules/order/party-order-file.component";
    import partyOrderCancel from "@/components/modules/order/party-order-cancel.component";
    const columns = [
        {
            title: "宝宝姓名",
            dataIndex: "name"
        },
        {
            title: "宝宝生日",
            dataIndex: "birthday"
        },
        {
            title: "宝宝性别",
            dataIndex: "gender"
        },
        {
            title: "宝宝与客户关系",
            dataIndex: "withConsumer"
        }
    ];
    const columnsProceeds = [
        {
            title: "NO",
            dataIndex: "index"
        },
        {
            title: "收款金额",
            dataIndex: "amount",
            scopedSlots: { customRender: 'amount' }
        },
        {
            title: "收款类型",
            dataIndex: "type"
        },
        {
            title: "收款方式",
            dataIndex: "mode"
        },
        {
            title: "收款日期",
            dataIndex: "actionDate"
        },
        {
            title: "收款人",
            dataIndex: "staff"
        },
        {
            title: "操作时间",
            dataIndex: "createTime"
        },
        {
            title: "备注",
            dataIndex: "remark"
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: 'action' }
        }
    ];
    const columnsRefund = [
        {
            title: "NO",
            dataIndex: "index"
        },
        {
            title: "退款金额",
            dataIndex: "amount",
            scopedSlots: { customRender: 'amount' }
        },
        {
            title: "退款方式",
            dataIndex: "mode"
        },
        {
            title: "退款日期",
            dataIndex: "actionDate"
        },
        {
            title: "退款人",
            dataIndex: "staff"
        },
        {
            title: "操作时间",
            dataIndex: "createTime"
        },
        {
            title: "备注",
            dataIndex: "remark"
        },
        {
            title: "操作",
            dataIndex: "action",
            scopedSlots: { customRender: 'action' }
        }
    ];
    const columnsOperationLog = [
        {
            title: "操作时间",
            dataIndex: "createTime"
        },
        {
            title: "动作",
            dataIndex: "action"
        },
        {
            title: "操作人",
            dataIndex: "operator"
        },
        {
            title: "操作人角色",
            dataIndex: "operatorRole"
        },
        {
            title: "备注",
            dataIndex: "remark"
        }
    ];
    const columnsArchive = [
        {
            title: "商品",
            dataIndex: "category",
            width: "20%",
            scopedSlots: { customRender: 'fontWeight' },
        },
        {
            title: "预售金额",
            dataIndex: "presell",
            scopedSlots: { customRender: 'myToFixed2' },
            width: "20%"
        },
        {
            title: "成本价",
            dataIndex: "cost",
            scopedSlots: { customRender: 'myToFixed2' },
            width: "20%"
        },
        {
            title: "实收金额",
            dataIndex: "payment",
            scopedSlots: { customRender: 'myToFixed2' },
            width: "20%"
        },
        {
            title: "利润",
            dataIndex: "profit",
            scopedSlots: { customRender: 'myToFixed2' },
            width: "20%"
        }
    ];
    export default {
        name: "partyOrderDetail",
        components: {
            partyOrderGetFiles,
            partyOrderCollection,
            partyOrderRefund,
            partyOrderFile,
            partyOrderCancel
        },
        data() {
            return {
                columns,
                columnsProceeds,
                columnsRefund,
                columnsOperationLog,
                columnsArchive,
                spinning: 0,
                detailData: {
                    partyOrderBabyVoList: [],
                    partyStartTime: '00:00:00',
                    partyEndTime: '00:00:00',
                },
                activeKey: 1,
                tabBarStyle: {
                    borderBottom: 0,
                    marginBottom: '1px'
                },
                partyOrderProceedsData: {
                    partyOrderProceedsVos: [],
                    total: 0
                },
                partyOrderRefundData: {
                    partyOrderRefundVos: [],
                    total: 0
                },
                partyOrderOperationLogData: [],
                partyOrderArchiveData: []
            };
        },
        computed: {},
        watch: {
            $route() {
                this.reflash();
            }
        },
        created() {},
        mounted() {
            this.scrollEl = document.getElementsByClassName('main-container-cover')[0];
            this.targetEl = document.getElementsByClassName('party-order-detail-block');
            this.scrollEl.addEventListener('scroll', this.scrollEvent);
            this.reflash();
        },
        beforeDestroy() {
            this.scrollEl.removeEventListener('scroll', this.scrollEvent);
        },
        methods: {
            /**
             * @reflash 页面数据刷新
             */
            reflash(e) {
                this.getDetail();
                this.getPartyOrderProceedsData();
                this.getPartyOrderRefundData();
                this.getPartyOrderOperationLog();
                this.partyOrderGetArchive();
            },
            /**
             * @scrollEvent 滚动回调
             */
            scrollEvent(e) {
                if (this.scrollLock) {
                    return false;
                }
                let currentValue = e.target.scrollTop;
                let targetEl = Array.prototype.filter.call(this.targetEl, i => i.getAttribute("style") !== 'display: none;');
                let targetValueMap = targetEl.map((i) => (i.offsetTop - 80));
                if ((e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight) === 0) {
                    this.activeKey = this.targetEl.length;
                    return true;
                }
                let activeKey = 1;
                targetValueMap.forEach((item, index) => {
                    if (currentValue > item) {
                        activeKey = index + 1;
                    }
                });
                this.activeKey = activeKey;
            },
            /**
             * @changeTab tab点击回调
             */
            changeTab(val) {
                let targetValueMap = Array.prototype.map.call(this.targetEl, (i) => (i.offsetTop - 80));
                this.activeKey = val;
                this.scrollLock = true;
                this.scrollEl.scrollTop = targetValueMap[val - 1];
                setTimeout(() => {
                    this.scrollLock = false;
                }, 100);
            },
            /**
             * @func getDetail 获取订单详情
             */
            getDetail() {
                let orderId = this.$route.params.orderId;
                if (!Boolean(orderId)) {
                    this.back();
                }
                this.spinning++;
                this.$api.order.partyOrderDetail({
                    params: {
                        id: orderId
                    }
                }).then(res => {
                    this.detailData = res;
                    this.spinning--;
                });
            },
            /**
             * @func getPartyOrderProceedsData 获取收款记录
             */
            getPartyOrderProceedsData() {
                let orderId = this.$route.params.orderId;
                this.spinning++;
                this.$api.order.partyOrderProceedsData({
                    query: {
                        orderId
                    }
                }).then(res => {
                    this.spinning--;
                    res.partyOrderProceedsVos.forEach((i, index) => i.index = index + 1);
                    this.partyOrderProceedsData = res;
                });
            },
            /**
             * @func getPartyOrderRefundData 获取退款记录
             */
            getPartyOrderRefundData() {
                let orderId = this.$route.params.orderId;
                this.spinning++;
                this.$api.order.partyOrderRefundData({
                    query: {
                        orderId
                    }
                }).then(res => {
                    this.spinning--;
                    res.partyOrderRefundVos.forEach((i, index) => i.index = index + 1);
                    this.partyOrderRefundData = res;
                });
            },
            /**
             * @func getPartyOrderOperationLog 获取操作记录
             */
            getPartyOrderOperationLog() {
                let orderId = this.$route.params.orderId;
                this.spinning++;
                this.$api.order.partyOrderOperationLog({
                    query: {
                        orderId
                    }
                }).then(res => {
                    this.spinning--;
                    this.partyOrderOperationLogData = res;
                });
            },
            /**
             * @func OpenGetFiles 查看附件
             */
            openGetFiles(isProceeds, id) {
                this.$refs.partyOrderGetFiles.open(isProceeds, id);
            },
            /**
             * @func openCollection 打开收款弹窗
             */
            openCollection(isRepair) {
                this.$refs.partyOrderCollection.open(isRepair, this.$route.params.orderId);
            },
            /**
             * @func openRefund 打开退款弹窗
             */
            openRefund(isRepair) {
                this.$refs.partyOrderRefund.open(isRepair, this.$route.params.orderId);
            },
            /**
             * @func openCancel 打开取消弹窗
             */
            openCancel() {
                this.$refs.partyOrderCancel.open(this.$route.params.orderId);
            },
            /**
             * @func openFile 打开归档弹窗
             */
            openFile() {
                this.$refs.partyOrderFile.open(this.$route.params.orderId);
            },
            /**
             * @func partyOrderGetArchive 派对订单归档信息
             */
            partyOrderGetArchive() {
                let orderId = this.$route.params.orderId;
                this.spinning++;
                this.$api.order.partyOrderGetArchive({
                    query: {
                        orderId
                    }
                }).then(res => {
                    this.spinning--;
                    if (!Boolean(res)) {
                        return false;
                    }
                    this.partyOrderArchiveData = [
                        {
                            category: '门票',
                            presell: res.ticketPresell,
                            cost: res.ticketCost,
                            payment: res.ticketPayment,
                            profit: res.ticketProfit,
                            fontWeight: false,
                        },
                        {
                            category: '餐饮',
                            presell: res.cateringPresell,
                            cost: res.cateringCost,
                            payment: res.cateringPayment,
                            profit: res.cateringProfit,
                            fontWeight: false,
                        },
                        {
                            category: '装饰',
                            presell: res.decoratePresell,
                            cost: res.decorateCost,
                            payment: res.decoratePayment,
                            profit: res.decorateProfit,
                            fontWeight: false,
                        },
                        {
                            category: '增值服务',
                            presell: res.servicePresell,
                            cost: res.serviceCost,
                            payment: res.servicePayment,
                            profit: res.serviceProfit,
                            fontWeight: false,
                        },
                        {
                            category: '小计',
                            presell: res.totalPresell,
                            cost: res.totalCost,
                            payment: res.totalPayment,
                            profit: res.totalProfit,
                            fontWeight: true,
                        },
                    ];
                });
            },
            back() {
                this.$router.back();
            },
        },
            };
</script>
<style lang="scss">
    #parte-order-detail-header {
        position: sticky;
        top: 0;
        z-index: 20;
        background: #ffffff;
        padding-top: 24px;
            box-shadow: 0 0 7px #cccccc;
        
    }
    .parte-order-detail {
        .wrap-header {
            padding: 0;
        }
    }
</style>